module.exports = __webpack_public_path__ + "static/media/cmu.0deef015.png";